<template>
  <div class="md my-3">
    <div class="row my-2 py-2 mx-2 align-items-center justify-content-center">
      <div class="col-auto ms-auto mt-2">
        <div class="lang-switcher">
          <!-- Flag SVGs sourced from Wikimedia Commons. No attribution required as national flags are not subject to copyright. -->
          <button class="lang-btn lang-btn-left" :class="{ active: !showEnglish }" @click="showEnglish = !showEnglish">
            <img src="/Flag_of_the_Netherlands.svg" alt="Nederlands">
          </button>
          <button class="lang-btn lang-btn-right" :class="{ active: showEnglish }" @click="showEnglish = !showEnglish">
            <img src="/Flag_of_the_United_Kingdom_(3-5).svg" alt="English">
          </button>
        </div>
      </div>
      <div class="col col-12 mt-2">
        <p v-if="!showEnglish" v-html="short_description_nl"></p>
        <p v-else v-html="short_description_en"></p>
      </div>
      <div class="col col-5 mb-2">
        <img src="/images/steven_van_gemert.png">
      </div>
      <div class="col col-5 mb-2">
        <img src="/images/aws-certified-solutions-architect.png">
      </div>
    </div>
  </div>
</template>

<script>
import { short_description_nl, short_description_en } from '@/portfolio/description.js'

export default {
  data() {
    return {
      showEnglish: true,
      short_description_nl,
      short_description_en,
    }
  },
  created () {
    // keep old single page application links backwards compatible
    const fragment = this.$route.hash.substring(1)
    const fragment_regex = /^\/blog\/[a-zA-Z0-9-]+$/
    const matches = fragment_regex.exec(fragment)
    if (matches) {
      console.debug('Forwarding to blogpost to keep old style single page application links working')
      this.$router.replace(fragment)
      return
    }
    console.debug('Page fragment will not cause forwarding:', fragment)

    document.title = "Home"
  }
}
</script>

<style scoped>
.md {
  text-align: left;
  background-color: rgb(43, 43, 43);
  border-radius: 10px;
}
.title {
  font-family: "Courier New", Courier, monospace;
}
img {
  width: 100%;
}

.lang-switcher {
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  overflow: hidden;
}
.lang-btn {
  background: transparent;
  border: none;
  padding: 4px 0;
  width: 40px;
  cursor: pointer;
  opacity: 0.4;
  transition: background 0.2s, opacity 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lang-btn.active {
  background: rgba(255, 255, 255, 0.15);
  opacity: 1;
}
.lang-btn-left {
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}
.lang-btn img {
  width: auto;
  height: 18px;
  display: block;
}
</style>
